export default (editor, pfx) => {
  const $ = editor.$;
  const themesEl =
    $(`<div id="${pfx}pn-themes-container" class="${pfx}fadein" style="width: 96%; flex-direction: column;">
        <div class="gjs-pn-content-header">Pages</div>
        <div class="pages-app">
        </div>
    </div>`);

  const pagesApp = themesEl.find(".pages-app");
  pagesApp.append(editor.PagesApp.render());

  return themesEl;
};
